import { Outlet, RouteObject } from 'react-router-dom';
import UserFeaturesGuard from '~/guards/UserFeaturesGuard';
import { RouteConfig } from '~/routes/routeConfig';
import { FeatureFlag, UserRole } from '~/types/company';
import lazyImport from '~/utils/lazyImport';
import CardsGuard from './cards/CardsGuard';
import { cardsRoutes } from './cards/cards-routes';

const AccountsInfo = lazyImport(() => import('~/views/accounts/AccountsInfo'));
const CashbackInfo = lazyImport(() => import('~/views/accounts/CashbackInfo'));
const CreditLinesPage = lazyImport(() => import('~/views/accounts/credit-lines/CreditLinesPage'));
const BankingView = lazyImport(() => import('./BankingView'));
const BankingViewWithConsentCreation = lazyImport(() => import('./BankingViewWithConsentCreation'));
const UserBankAccountOnboarding = lazyImport(() => import('./userBankAccounts/UserBankAccountOnboarding'));

export const accountsRoutes: RouteObject[] = [
  {
    path: 'new',
    element: (
      <UserFeaturesGuard requiredFeatures={[FeatureFlag.Treasury]} whitelistedRoles={[UserRole.ENTREPRENEUR]}>
        <BankingViewWithConsentCreation />
      </UserFeaturesGuard>
    ),
  },
  {
    path: 'cards/*',
    element: (
      <CardsGuard>
        <Outlet />
      </CardsGuard>
    ),
    children: cardsRoutes,
  },
  {
    path: 'info',
    element: (
      <UserFeaturesGuard requiredFeatures={[FeatureFlag.Treasury]} whitelistedRoles={[UserRole.ENTREPRENEUR]}>
        <AccountsInfo />
      </UserFeaturesGuard>
    ),
  },
  {
    path: 'cashback',
    element: (
      <UserFeaturesGuard requiredFeatures={[FeatureFlag.Treasury]} whitelistedRoles={[UserRole.ENTREPRENEUR]}>
        <CashbackInfo />
      </UserFeaturesGuard>
    ),
  },
  {
    path: 'credit-lines',
    element: (
      <UserFeaturesGuard
        redirectTo={RouteConfig.Accounts.buildLink()}
        requiredFeatures={[FeatureFlag.Treasury, FeatureFlag.CreditLines]}
        whitelistedRoles={[UserRole.ENTREPRENEUR]}
      >
        <CreditLinesPage />
      </UserFeaturesGuard>
    ),
  },
  {
    path: 'user-bank-accounts/onboarding',
    element: <UserBankAccountOnboarding />,
  },
  {
    path: '*',
    element: (
      <UserFeaturesGuard requiredFeatures={[FeatureFlag.Treasury]} whitelistedRoles={[UserRole.ENTREPRENEUR]}>
        <BankingView />
      </UserFeaturesGuard>
    ),
  },
];
